import {
  RouteConfig
} from 'vue-router'
import Layout from '@/layout/index.vue'

const paysRouter: RouteConfig = {
  path: '/pays',
  component: Layout,
  redirect: '/pays/payOrders',
  name: '财务管理',
  meta: {
    title: '财务管理',
    icon: 'pays',
    permissions: ['Pages.Administration'],
  },
  children: [
    {
      path: 'paymentCategory_list',
      name: 'paymentCategory_list',
      component: () => import(/* webpackChunkName: "pays" */'@/views/admin/finance/paymentCategory.vue'),
      meta: {
        title: '款项分类'
      }
    },
    {
      path: 'salary',
      name: 'salary',
      component: () => import(/* webpackChunkName: "pays" */'@/views/pays/payroll/salary/list.vue'),
      meta: {
        title: '工资单'
      }
    },
    {
      path: 'incomeSupplement',
      name: 'incomeSupplement',
      component: () => import(/* webpackChunkName: "pays" */'@/views/pays/incomeSupplement.vue'),
      meta: {
        title: '收入补录'
      }
    },
    {
      path: 'payrollRequisitionList',
      name: 'payrollRequisitionList',
      component: () => import(/* webpackChunkName: "pays-payroll-requisition" */'@/views/pays/payrollRequisitionList.vue'),
      meta: {
        title: '请款单'
      }
    },
    {
      path: 'reimbursementList/org',
      name: 'reimbursementList',
      component: () => import(/* webpackChunkName: "pays-reimbursement" */'@/views/pays/reimbursementToOrg.vue'),
      meta: {
        title: '报销到单位'
      }
    },
    {
      path: 'reimbursementList/project',
      name: 'reimbursementList',
      component: () => import(/* webpackChunkName: "pays-reimbursement" */'@/views/pays/reimbursementToProject.vue'),
      meta: {
        title: '报销到项目'
      }
    },
    {
      path: 'payOrders',
      name: 'payOrders',
      component: () => import(/* webpackChunkName: "pays-order" */'@/views/pays/payOrderList.vue'),
      meta: {
        title: '支付订单信息'
      }
    },
    {
      path: 'refundOrders',
      name: 'refundOrders',
      component: () => import(/* webpackChunkName: "pays-order" */'@/views/pays/refundLogList.vue'),
      meta: {
        title: '退款列表'
      }
    },
    {
      path: 'import/result/:reportName',
      name: 'uploadTemplateDetail',
      component: () => import(/* webpackChunkName: "pays" */'@/components/UploadTemplate/result.vue'),
      meta: {
        title: '模板导入结果'
      }
    },
    // 分账报表信息
    {
      path: 'splitAccount/bills',
      name: 'splitAccountBills',
      component: () => import(/* webpackChunkName: "pays-split" */'@/views/pays/splitOrder/billList.vue'),
      meta: {
        title: '分账账单'
      }
    },
    {
      path:'splitAccount/bill/details/:billId',
      name:'splitAccountBillDetails',
      component: ()=> import(/* webpackChunkName: "pays-split" */'@/views/pays/splitOrder/billDetails.vue'),
      meta:{
        title: '分账账单明细'
      }
    },
    {
      path:'splitAccount/bill/allDetails',
      name:'splitAccountBillAllDetails',
      component: ()=> import(/* webpackChunkName: "pays-split" */'@/views/pays/splitOrder/billDetails.vue'),
      meta:{
        title: '分账明细记录'
      }
    }
  ]
}

export default paysRouter
